export enum ViewMode {
  VEHICLE = 'VEHICLE',
  PROFILE = 'PROFILE',
  AREA = 'AREA',
  CLAIM = 'CLAIM',
  CARE = 'CARE',
  SHARE = 'SHARE',
  BOOKING = 'BOOKING',
  CATEGORIES = 'CATEGORIES',
  PRICING = 'PRICING',
  CIRCLE = 'CIRCLE',
  USERS = 'USERS',
  ADMINS = 'ADMINS',
  RECEIPTS = 'RECEIPTS',
  FUEL_TRANSACTIONS = 'FUEL_TRANSACTIONS',
  PRIVACY_POLICY = 'PRIVACY_POLICY',
  REPORTS = 'REPORTS',
}
